import type { ReactNode } from 'react';

export const symbol_hearing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-608q0 66-21 127.5T697-368q-8 11-8.5 24t9.5 22q10 9 23.5 7t21.5-13q47-60 72-131t25-149q0-77-24-149t-72-131q-8-11-22-12.5t-24 7.5q-10 8-9 21t9 23q42 51 62 113t20 128Zm-316 70q27-27 27-66t-27-67q-27-28-66-28t-67 28q-28 28-28 67t28 66q28 27 67 27t66-27ZM181-224q0-13-8.5-21.5T151-254q-13 0-21.5 8.5T121-224q4 60 47.5 101.5T272-81q57 0 99-31t62-82q20-51 39.5-79.5T546-345q66-53 95-113t29-146q0-120-76-196.5T398-877q-118 0-196 73.5T120-616q0 13 8.5 21.5T150-586q13 0 21.5-8.5T180-616q4-88 65-144.5T398-817q90 0 151 61.5T610-604q0 72-28 124.5T489-378q-39 29-62.5 63T382-231q-17 42-44.5 66T272-141q-35 0-61-24t-30-59Z"
		/>
	</svg>
);
